export default __webpack_public_path__ + "static/media/pause.ea64ab57.svg";